import { ref, computed } from 'vue';

const userCurrency = ref('MAD');
const userCountry = ref(null);
const isLoading = ref(true);

export function useCurrency() {
  const detectUserCurrency = async () => {
    if (userCountry.value !== null) return;

    try {
      const response = await fetch('https://api.country.is/');
      if (response.ok) {
        const data = await response.json();
        console.log('IP API response:', data);
        userCountry.value = data.country;
        userCurrency.value = data.country === 'MA' ? 'MAD' : 'EUR';
      } else {
        throw new Error('API failed');
      }
    } catch (err) {
      console.log('IP detection failed, using timezone fallback:', err.message);
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      console.log('User timezone:', timezone);
      
      if (timezone.includes('Casablanca') || timezone.includes('Tangier') || timezone.includes('Rabat') || timezone.includes('Morocco')) {
        userCurrency.value = 'MAD';
        userCountry.value = 'MA';
      } else if (timezone.includes('Europe/')) {
        userCurrency.value = 'EUR';
        userCountry.value = 'EU';
      } else {
        const browserLang = navigator.language || navigator.languages?.[0] || 'en';
        if (browserLang.startsWith('ar') || browserLang.startsWith('fr')) {
          userCurrency.value = 'MAD';
          userCountry.value = 'MA';
        } else {
          userCurrency.value = 'EUR';
          userCountry.value = 'EU';
        }
      }
    } finally {
      isLoading.value = false;
    }
  };

  const currencySymbol = computed(() => {
    if (userCurrency.value === 'MAD') {
      return { code: 'MAD', symbol: 'MAD', conversionRate: 0.1 };
    } else {
      return { code: 'EUR', symbol: '€', conversionRate: 10 };
    }
  });

  const formatPrice = (madPrice) => {
    if (userCurrency.value === 'MAD') {
      return `${madPrice} MAD`;
    } else {
      const eurPrice = Math.round(madPrice * 0.1);
      return `${eurPrice} €`;
    }
  };

  const formatPriceWithUnit = (madPrice, period) => {
    if (userCurrency.value === 'MAD') {
      return `${madPrice} MAD/${period}`;
    } else {
      const eurPrice = Math.round(madPrice * 0.1);
      return `${eurPrice} €/${period}`;
    }
  };

  return {
    userCurrency,
    userCountry,
    isLoading,
    currencySymbol,
    formatPrice,
    formatPriceWithUnit,
    detectUserCurrency
  };
}